import { createApi } from '@reduxjs/toolkit/query/react';

import { AcceptPlatformInviteAPIProps } from '@scaleup/models';
import { baseQuery } from './baseQuery';

export const inviteApi = createApi({
  reducerPath: 'inviteApi',
  baseQuery: baseQuery,
  tagTypes: [],
  endpoints: (builder) => ({
    getInviteStatus: builder.query<void, string>({
      query: (token) => `/invite/status?inviteToken=${token}`,
      providesTags: [],
    }),
    acceptInvite: builder.mutation<void, AcceptPlatformInviteAPIProps>({
      query: (req) => ({
        url: `/invite/accept`,
        method: 'POST',
        body: req,
      }),
    }),
  }),
});

export const { useLazyGetInviteStatusQuery, useAcceptInviteMutation } =
  inviteApi;
